// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"325":"86f52004","459":"db7e656d","611":"701efddd","774":"7da88004","787":"5f0322ff"}[chunkId] + ".chunk.js";
};